export default { sha: 'fa3212e6aa766efd1b9bd6fa2795ddd89c1fca45', buildNumber: 'undefined' }
